import {useCallback, useState} from 'react'
import {Button, Spinner} from '@primer/react'
import styles from './FooterActions.module.css'

interface FooterActionsProps {
  disabled?: boolean
  onCancel: () => void
  onApply: () => void
  checkStatus?: (callback: () => void) => void
  showError?: boolean
  nextFocusRef?: React.RefObject<HTMLElement | null>
  overrideButtonStyles?: React.CSSProperties
}

function FooterActions({
  nextFocusRef,
  onApply,
  checkStatus,
  onCancel,
  disabled,
  showError,
  overrideButtonStyles,
}: FooterActionsProps) {
  const [showLoading, setShowLoading] = useState(false)

  const onBlur: React.FocusEventHandler<HTMLElement> = useCallback(() => {
    nextFocusRef?.current?.focus()
    return true
  }, [nextFocusRef])

  const displayLoading = useCallback(() => {
    setShowLoading(true)
  }, [])

  const onApplyHandler = useCallback(() => {
    onApply()

    setTimeout(() => {
      if (checkStatus) checkStatus(displayLoading)
    }, 600)
  }, [onApply, checkStatus, displayLoading])

  return (
    <div className={styles.footerContainer}>
      {showError ? <span className={styles.errorMessageText}>Error. Please try again.</span> : null}
      <div className={styles.buttonsContainer} style={overrideButtonStyles ?? {padding: 'var(--base-size-16)'}}>
        {!showError && showLoading ? <Spinner size="small" className={styles.FooterActionsSpinner} /> : null}
        <Button
          size="small"
          onClick={() => onCancel()}
          onBlur={event => {
            if (disabled) {
              onBlur(event)
            }
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={disabled}
          variant="primary"
          size="small"
          onClick={() => onApplyHandler()}
          onBlur={onBlur}
          className={styles.applyButton}
        >
          Apply
        </Button>
      </div>
    </div>
  )
}

export default FooterActions
